import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    const userData = authService.getUserData();
    if (userData?.is_expired && state.url !== '/trial-expired') {
      router.navigate(['/trial-expired']);
      return false;
    }
    if (!userData?.is_expired && state.url === '/trial-expired') {
      router.navigate(['/']);
      return false;
    }
    return true;
  }

  // Redirect to the login page with a return url
  router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
  return false;
};

export const loginGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    const userData = authService.getUserData();
    if (userData?.is_expired) {
      router.navigate(['/trial-expired']);
    } else {
      router.navigate(['/']);
    }
    return false;
  }

  return true;
};
